import { chatHistorySampleData } from '../constants/chatHistory'
import { getOrCreateUserId } from '../utils/identity/identity'
//import axios from "axios";
//comments


import { ChatMessage, Conversation, ConversationRequest, CosmosDBHealth, CosmosDBStatus, UserInfo } from './models'

let SUBSCRIPTION_KEY = "";

let frontendConfigLoadPromise: Promise<void> | null = null

export async function loadFrontendConfig(): Promise<void> {
  const response = await fetch("/api/frontend-config");
  const config = await response.json();
  SUBSCRIPTION_KEY = config.OCP_APIM_SUBSCRIPTION_KEY;
}

async function ensureFrontendConfigLoaded(): Promise<void> {
  if (SUBSCRIPTION_KEY) return
  if (!frontendConfigLoadPromise) {
    frontendConfigLoadPromise = loadFrontendConfig().finally(() => {
      // Allow retry on next attempt if the key is still missing.
      if (!SUBSCRIPTION_KEY) frontendConfigLoadPromise = null
    })
  }
  await frontendConfigLoadPromise
}


//export function getAnonHeaders(): HeadersInit {
export function getAnonHeaders(): Record<string,string>{
  if (!SUBSCRIPTION_KEY) {
    console.error("FATAL: Subscription key is empty — request will be rejected by APIM.");
    console.trace("Called from:");
  }

  return {
    'Content-Type': 'application/json',
    'X-Anonymous-User-Id': getOrCreateUserId(),
    'Ocp-Apim-Session-Key': crypto.randomUUID(), // Optional: Per-request session trace
    'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
  };
}

/*
export const fetchDocumentNames = async (selectedDocument?: string): Promise<string[]> => { 
  try {
    // Ensure config is loaded before making the request
    if (!SUBSCRIPTION_KEY) {
      await loadFrontendConfig();
    }
      const searchPayload = {
          search: "*",
          filter: selectedDocument ? `filepath eq '${selectedDocument}'` : undefined,
          select: "filepath",
          top: 1000
      };
      const response = await fetch("/api/search", {
                method: "POST",
                headers: getAnonHeaders(),
                body: JSON.stringify(searchPayload),
              });
       
      const data = await response.json();
      //const response = await axios.post(
      //    "/api/search",  // Backend proxy call
      //    searchPayload,
      //    {
      //        headers: getAnonHeaders() 
      //   }
      //);

      // Extract and deduplicate filepaths
      const filepaths: string[] = data.value.map((doc: { filepath: string }) => doc.filepath.trim());
      //const filepaths: string[] = response.data.value.map((doc: { filepath: string }) => doc.filepath.trim());
      const uniqueFilepaths: string[] = Array.from(new Set<string>(filepaths));
      
      return uniqueFilepaths;
  } catch (error: any) {
      console.error('Azure Search Proxy Error');
      throw error;
  }
};
*/

//(STA Chatbot changes) Added Selected Documents to be used in the filter
export async function conversationApi(options: ConversationRequest, abortSignal: AbortSignal, selectedDocuments?: string[]): Promise<Response> {
  try {
    await ensureFrontendConfigLoaded()
   
    const validDocuments = selectedDocuments?.filter(doc => doc.trim() !== "");

    const filterString = validDocuments && validDocuments.length > 0
        ? validDocuments.map(doc => `filepath eq '${doc}'`).join(" or ")
        : undefined; //  No filter applied if no valid document selected

    const requestBody = {
        messages: options.messages,
        filter: filterString, //  Ensures the OData filter is correctly formatted
        //selectedDocuments: validDocuments.length > 0 ? validDocuments : undefined //  Prevent empty selections
        selectedDocuments: validDocuments && validDocuments.length > 0 ? validDocuments : undefined

    };
    
    //  Send anonymous ID in header
    const response = await fetch('/conversation', {
        method: 'POST',
        headers: getAnonHeaders(),
        body: JSON.stringify(requestBody),
        signal: abortSignal
    });

    if (!response.ok) {
        console.error('Conversation API Error:', {
            status: response.status,
            statusText: response.statusText
        });
    }
    
    return response;
} catch (error) {
    console.error('API Error:', error);
    throw error;
}
}

export async function getUserInfo(): Promise<UserInfo[]> {
  const response = await fetch('/.auth/me')
  if (!response.ok) {
    console.log('No identity provider found. Access to chat will be blocked.')
    return []
  }

  const payload = await response.json()
  return payload
}

// export const fetchChatHistoryInit = async (): Promise<Conversation[] | null> => {
export const fetchChatHistoryInit = (): Conversation[] | null => {
  // Make initial API call here

  return chatHistorySampleData
}

export const historyList = async (offset = 0): Promise<Conversation[] | null> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch(`/history/list?offset=${offset}`, {
    method: 'GET',
    headers: getAnonHeaders()
  })
    .then(async res => {
      const payload = await res.json()
      if (!Array.isArray(payload)) {
        console.error('There was an issue fetching your data.')
        return null
      }
      const conversations: Conversation[] = await Promise.all(
        payload.map(async (conv: any) => {
          let convMessages: ChatMessage[] = []
          convMessages = await historyRead(conv.id)
            .then(res => {
              return res
            })
            .catch(err => {
              console.error('error fetching messages: ', err)
              return []
            })
          const conversation: Conversation = {
            id: conv.id,
            title: conv.title,
            date: conv.createdAt,
            messages: convMessages
          }
          return conversation
        })
      )
      return conversations
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      return null
    })

  return response
}

export const historyRead = async (convId: string): Promise<ChatMessage[]> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/read', {
    method: 'POST',
    body: JSON.stringify({
      conversation_id: convId
    }),
    headers: getAnonHeaders()
    //headers: {
    //  'Content-Type': 'application/json'
    //}
  })
    .then(async res => {
      if (!res) {
        return []
      }
      const payload = await res.json()
      const messages: ChatMessage[] = []
      if (payload?.messages) {
        payload.messages.forEach((msg: any) => {
          const message: ChatMessage = {
            id: msg.id,
            role: msg.role,
            date: msg.createdAt,
            content: msg.content,
            feedback: msg.feedback ?? undefined
          }
          messages.push(message)
        })
      }
      return messages
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      return []
    })
  return response
}

export const historyGenerate = async (
  options: ConversationRequest,
  abortSignal: AbortSignal,
  convId?: string
): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  let body
  if (convId) {
    body = JSON.stringify({
      conversation_id: convId,
      messages: options.messages,
      filter: options.filter ?? null,  
      selectedDocuments: options.selectedDocuments ?? []
    })
  } else {
    body = JSON.stringify({
      messages: options.messages,
      filter: options.filter ?? null,  //  Ensure filter is included
      selectedDocuments: options.selectedDocuments ?? []  //  Ensure selectedDocuments is included
    })
  }
  const response = await fetch('/history/generate', {
    method: 'POST',
    headers: getAnonHeaders(),
    //headers: {
    //  'Content-Type': 'application/json'
    //},
    body: body,
    signal: abortSignal
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      return new Response()
    })
  return response
}

export const historyUpdate = async (messages: ChatMessage[], convId: string): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/update', {
    method: 'POST',
      body: JSON.stringify({
      conversation_id: convId,
      messages: messages
    }),
    headers: getAnonHeaders()
    //headers: {
    // 'Content-Type': 'application/json'
    //}
  })
    .then(async res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}

export const historyDelete = async (convId: string): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/delete', {
    method: 'DELETE',
    body: JSON.stringify({
      conversation_id: convId
    }),
    headers: getAnonHeaders()
    //headers: {
    //  'Content-Type': 'application/json'
    //}
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}

export const historyDeleteAll = async (): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/delete_all', {
    method: 'DELETE',
    body: JSON.stringify({}),
    headers: getAnonHeaders()
    //headers: {
    //  'Content-Type': 'application/json'
    //}
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}

export const historyClear = async (convId: string): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/clear', {
    method: 'POST',
    body: JSON.stringify({
      conversation_id: convId
    }),
    headers: getAnonHeaders()
    //headers: {
    //  'Content-Type': 'application/json'
    //}
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}

export const historyRename = async (convId: string, title: string): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/rename', {
    method: 'POST',
    body: JSON.stringify({
      conversation_id: convId,
      title: title
    }),
    headers: getAnonHeaders()
    //headers: {
     // 'Content-Type': 'application/json'
    //}
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}

export const historyEnsure = async (): Promise<CosmosDBHealth> => {
  await ensureFrontendConfigLoaded()

  const response = await fetch('/history/ensure', {
    method: 'GET',
    headers: getAnonHeaders()
  })
    .then(async res => {
      const respJson = await res.json()
      let formattedResponse
      if (respJson.message) {
        formattedResponse = CosmosDBStatus.Working
      } else {
        if (res.status === 500) {
          formattedResponse = CosmosDBStatus.NotWorking
        } else if (res.status === 401) {
          formattedResponse = CosmosDBStatus.InvalidCredentials
        } else if (res.status === 422) {
          formattedResponse = respJson.error
        } else {
          formattedResponse = CosmosDBStatus.NotConfigured
        }
      }
      if (!res.ok) {
        return {
          cosmosDB: false,
          status: formattedResponse
        }
      } else {
        return {
          cosmosDB: true,
          status: formattedResponse
        }
      }
    })
    .catch(err => {
      console.error('There was an issue fetching your data.')
      return {
        cosmosDB: false,
        status: err
      }
    })
  return response
}

export const frontendSettings = async (): Promise<Response | null> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/frontend_settings', {
    method: 'GET',
    headers: getAnonHeaders()
  })
    .then(res => {
      return res.json()
    })
    .catch(_err => {
      console.error('There was an issue fetching your data.')
      return null
    })

  return response
}
export const historyMessageFeedback = async (messageId: string, feedback: string): Promise<Response> => {
  await ensureFrontendConfigLoaded()
  const response = await fetch('/history/message_feedback', {
    method: 'POST',
    body: JSON.stringify({
      message_id: messageId,
      message_feedback: feedback
    }),
    headers: getAnonHeaders()
    //headers: {
    //  'Content-Type': 'application/json'
    //}
  })
    .then(res => {
      return res
    })
    .catch(_err => {
      console.error('There was an issue logging feedback.')
      const errRes: Response = {
        ...new Response(),
        ok: false,
        status: 500
      }
      return errRes
    })
  return response
}